import { render, staticRenderFns } from "./BankEditView.vue?vue&type=template&id=2df35aec&scoped=true"
import script from "./BankEditView.vue?vue&type=script&lang=js"
export * from "./BankEditView.vue?vue&type=script&lang=js"
import style0 from "./BankEditView.vue?vue&type=style&index=0&id=2df35aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df35aec",
  null
  
)

export default component.exports